import React from "react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

//prime React
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

//components
import Select from "../../../../components/input/Select";

//services
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { Skeleton } from "primereact/skeleton";

export default function ClickSignSigners({
  id,
  registeredSigners,
  signers,
  refetchSigners,
  isLoadingSigners,
  refetchRegisterSigners,
  isLoadingRegisterSigners,
  config_sign,
  refetch,
  isLoading,
  sendPost,
  configEnterprise,
  idSale,
  deleteSigners,
}) {
  const [transformedData, setTransformedData] = useState([]);

  const [newSigner, setNewSigner] = useState([{}]);

  const [loading, setLoading] = useState(false);
  const columns = [
    { field: "id", header: "Nº Cadastro" },
    { field: "name", header: "Nome" },
    { field: "cpf", header: "CPF" },
    { field: "email", header: "E-mail" },
    { field: "signer_desc", header: "Tipo Signatário" },
  ];
  const transformedDataSigners = registeredSigners?.map((item) => ({
    id: item.id,
    name: item.user.name,
    cpf: item.user.doc,
    email: item.email_signer,
    signer_desc: item.label_type_signer,
  }));
  const handleAddSigners = () => {
    setNewSigner([...newSigner, {}]);
  };
  const handleRemoveSigners = (e, index) => {
    e.preventDefault();
    form.setValue(`signer[${index}]`, "");
    form.setValue(`type_sign[${index}]`, "");
    const updatedClients = [...newSigner];
    updatedClients.splice(index, 1);
    setNewSigner(updatedClients);
  };
  const removeSigner = (rowData) => {
    confirmDialog({
      message: "Você deseja deletar o signatário?",
      header: "Confirmação",
      icon: "fa-solid fa-ban",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: async () => {
        setLoading(true);
        const notification = toast.loading(
          "Um momento, deletando signatário..."
        );

        const id = rowData.id;

        try {
          await deleteSigners(id);
          await refetchRegisterSigners().then(() => {
            toast.update(notification, {
              render: "Signatário deletado com sucesso",
              autoClose: 1000,
              theme: "colored",
              type: "success",
              isLoading: false,
            });
          });
        } catch (err) {
          // Acessa e exibe a mensagem de erro específica
          const errorMessage =
            err?.errors && err?.errors.length > 0
              ? err?.errors.join(", ")
              : " Não foi possível deletar o Signatário";

          toast.update(notification, {
            render: errorMessage,
            autoClose: 3000,
            theme: "colored",
            type: "error",
            isLoading: false,
          });
        } finally {
          setLoading(false);
          form.reset();
          refetch();
        }
      },
      reject: () => {
        return;
      },
    });
  };

  const form = useForm();
  const errors = form.formState.errors;

  const transformData = (responseData) => {
    const { signerConfig, typeSigners } = responseData;

    const newData = typeSigners?.map((signer) => {
      const config = signerConfig.find(
        (config) => config.type_signer_id === signer.id
      );

      return {
        id: signer.id,
        name: signer.name,
        desc: signer.desc,
        type: signer.type,
        id_config: config ? config.id : 0,
        selfie: config ? Boolean(config.selfie_enabled) : false,
        photo_doc: config ? Boolean(config.official_document_enabled) : false,
        handwritten_signature: config
          ? Boolean(config.handwritten_enabled)
          : false,
      };
    });
    const filteredData = newData.filter((item) => item.id_config !== 0);
    return filteredData;
  };

  function onSubmit(data) {
    setLoading(true);
    const { signer, type_sign } = data;
    let obj;
    const datas = signer
      .map((signer_id, index) => {
        const user_id = type_sign[index];
        // Verifica se user_id e signer_id não são vazios
        return user_id !== undefined &&
          user_id !== "" &&
          signer_id !== "" &&
          signer_id !== undefined
          ? { user_id: signer_id, signer_id: user_id }
          : undefined;
      })
      .filter((item) => item !== undefined);

    if (configEnterprise) {
      obj = {
        enterprise_id: id,
        datas: datas,
      };
    } else {
      obj = {
        sale_id: idSale,
        signer_id: datas[0].signer_id,
        user_id: datas[0].user_id,
      };
    }

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );
    sendPost(obj)
      .then(() => {
        refetchRegisterSigners()
          .then(() => {
            toast.update(notification, {
              render: "Signatários adicionados com sucesso!",
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              type: "success",
              isLoading: false,
            });
          })
          .catch((error) => {
            console.error("Erro ao atualizar signatários:", error);
          });
      })
      .catch((error) => {
        //        console.log(error);
        toast.update(notification, {
          render: `Não foi possível adicionar os signatários! ${error}`,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao adicionar signatários:", error);
      })
      .finally(() => {
        setNewSigner([{}]);
        form.reset();
        setLoading(false);
      });
  }

  useEffect(() => {
    if (config_sign && config_sign.typeSigners) {
      const newData = transformData(config_sign);
      setTransformedData(newData);
    }
  }, [config_sign]);

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
        <div className="row">
          <div className="card-border me-2 my-2">
            <div className="title-container">
              <p>
                {" "}
                <i className="fa-solid fa-users me-2"></i>Signatários
              </p>
            </div>
            <div className="col-md-12 row my-2 p-4">
              <>
                <h4 className="text-success">
                  <i className="fa-solid fa-circle-plus mx-2"></i>Cadastro de
                  Signatários
                </h4>
                <hr></hr>
                {/* <FiltersOwners id={id} /> */}
                {newSigner.map((cli, index) => (
                  <div className="row" key={index}>
                    <div className="col-xl-4 col-md-6 mb-1">
                      <Select
                        isRequired={true}
                        name={`signer[${index}]`}
                        label={
                          isLoadingSigners ? "Carregando..." : "Signatário"
                        }
                        disabled={isLoadingSigners}
                        errors={errors}
                        control={form.control}
                        options={
                          signers &&
                          signers.map((item) => {
                            return {
                              value: item.id,
                              label: item.name,
                            };
                          })
                        }
                      />
                    </div>
                    <div className="col-xl-4 col-md-6 mb-1">
                      <Select
                        isRequired={true}
                        name={`type_sign[${index}]`}
                        label={
                          isLoading ? "Carregando..." : "Tipo de Signatário "
                        }
                        disabled={isLoading}
                        errors={errors}
                        control={form.control}
                        options={
                          transformedData &&
                          transformedData.map((item) => {
                            return {
                              value: item.id_config,
                              label: item.name,
                            };
                          })
                        }
                      />
                    </div>
                    <div className="col-md-2 ms-2 pt-4">
                      {index === newSigner.length - 1 && configEnterprise && (
                        <Button
                          rounded
                          outlined
                          size="small"
                          severity="success"
                          icon="fa fa-plus"
                          onClick={handleAddSigners}
                          className="mx-2 mt-1 pt-1"
                          style={{
                            width: "2rem",
                            height: "2rem",
                            padding: "2px",
                          }}
                        />
                      )}

                      {index > 0 && (
                        <Button
                          rounded
                          outlined
                          severity="danger"
                          icon="fa fa-minus"
                          className="mx-2 mt-1"
                          onClick={(e) => handleRemoveSigners(e, index)}
                          style={{
                            width: "2rem",
                            height: "2rem",
                            padding: "2px",
                          }}
                        />
                      )}
                    </div>
                  </div>
                ))}
                {sendPost && (
                  <div className="col-md-12 mt-4 align-self-end text-end">
                    {" "}
                    <Button
                      rounded
                      type="submit"
                      loading={loading}
                      iconPos="right"
                      label="Salvar"
                      icon="fa-solid fa-circle-chevron-right"
                      className="p-inputtext-sm m-auto"
                    />
                  </div>
                )}
              </>

              <h4 className="text-success mt-4">
                <i className="fa-solid fa-users mx-2"></i>Signatários
                Cadastrados
              </h4>
              <hr></hr>

              {isLoadingRegisterSigners || isLoadingRegisterSigners ? (
                <>
                  <Skeleton width="100%" height="150px" />
                </>
              ) : (
                <>
                  <DataTable
                    rows={5}
                    stripedRows
                    showGridlines
                    sortMode="multiple"
                    selectionMode="single"
                    value={transformedDataSigners}
                    emptyMessage="Nenhuma Informação foi encontrada."
                    tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                  >
                    {columns.map((col) => (
                      <Column
                        sortable
                        key={col.field}
                        field={col.field}
                        header={col.header}
                        body={col.body}
                      />
                    ))}
                    {deleteSigners && (
                      <Column
                        header="Excluir"
                        body={(rowData) => (
                          <div className="text-center">
                            <button
                              type="button"
                              className="btn btn-danger btn-btn-sm"
                              onClick={(e) => removeSigner(rowData)}
                            >
                              <i className="fa-solid fa-trash-can"></i>
                            </button>
                          </div>
                        )}
                      />
                    )}
                  </DataTable>
                </>
              )}
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
